const SET_ENTERPRISE_DATA = "SET_ENTERPRISE_DATA";


const initialState = {
  enterpriseList: {
    searchInput: "",
    currentPage: 0,
    totalPages: 0,
    totalResults: 0,
    listdata: [],
  },
};

export const setEnterpriseData = (payload) => ({
    type: SET_ENTERPRISE_DATA,
    payload,
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_ENTERPRISE_DATA:
            return {
                ...state,
                enterpriseList: {
                    ...state.enterpriseList,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
}